import AccessValidation from '@/shared/mixins/access-validation';
import NavigationBar from '@/shared/components/navigation-bar/index.vue';
import { NavItem, NavItemStatusID, NavItemTypeID } from '@/shared/components/navigation-bar/navigation-item';
import PageHeader from '@/shared/components/page-header/index.vue';
import { TrustAPI } from '@/shared/modules/trust-api';
import { CorrespondenceDescription, CorrespondenceType, InvestigationCategory, InvestigationView, LeaveType, NotesType, PracticeRisk, PracticeRiskIndicator, PracticeView, Priority, SolelyJointly, Status, TimeEntryActivity, TimeEntryType, TrustAccountStatus, TrustTeamMemberView, UserGroup } from '@/shared/modules/typescript-trustapi-client/models';
import { AuthorizedUser } from '@/trust-admin-app/models/authorized-user';
import { AuthenticationStatusType } from '@/trust-admin-app/modules/authentication/authentication-status';
import { IDLESessionManager } from '@/trust-admin-app/modules/session/idle-session-manager';
import { Options, Vue } from 'vue-class-component';
import { Inject, Provide, Watch } from 'vue-property-decorator';
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { RouteN } from '../../constants/router-name';
import store from '../../store';
import AddEditInvestigationModal from '../investigations-main/add-edit-investigation-modal/index.vue';
import AccountInfoPanel from '../trust-admin-rhs-header/account-info-panel/index.vue';
import LoadingSpinner from '@/shared/components/loading-spinner/index.vue';
import AddEventModal from '../add-event-modal/index.vue';
import { EventEmitter } from 'events';
import ErrorIndicator from '@/shared/components/error-indicator/index.vue';
import AddEditMemberModal from '../trust-data-trust-team/add-edit-member-modal/index.vue';
import { EventForm } from '@/trust-investigator-app/components/add-event-modal/event-form';
import { Url } from '@/trust-admin-app/config/url';
import InvestigationDetailsModal from "../investigation-details-modal/index.vue";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';


Vue.registerHooks(['beforeRouteEnter']);
@Options({
  components: {
    PageHeader,
    AccountInfoPanel,
    NavigationBar,
    AddEditInvestigationModal,
    LoadingSpinner,
    ErrorIndicator,
    AddEventModal,
    AddEditMemberModal,
    InvestigationDetailsModal,
  },
  mixins: [AccessValidation, FormatDateTimeMixin]
})
export default class TrustAdminMain extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Provide({ to: 'statusType', reactive: true })
  private statusType!: Status[];

  @Provide({ to: 'leaveType', reactive: true })
  private leaveType!: LeaveType[];

  @Provide({ to: 'investigationCategory', reactive: true })
  private investigationCategory!: InvestigationCategory[];

  @Provide({ to: 'timeEntryType', reactive: true })
  private timeEntryType!: TimeEntryType[];

  @Provide({ to: 'userGroups', reactive: true })
  private userGroups!: UserGroup[];

  @Provide({ to: 'timeEntryActivity', reactive: true })
  private timeEntryActivity!: TimeEntryActivity[];

  @Provide({ to: 'priorities', reactive: true })
  private priorities!: Priority[];

  @Provide({ to: 'trustAccountStatus', reactive: true })
  private trustAccountStatus!: TrustAccountStatus[];

  @Provide({ to: 'noteType', reactive: true })
  private noteType!: NotesType[];

  @Provide({ to: 'practiceRisks', reactive: true })
  private practiceRisks!: PracticeRisk[];

  @Provide({ to: 'practiceRiskIndicators', reactive: true })
  private practiceRiskIndicators!: PracticeRiskIndicator[];

  @Provide({ to: 'correspondenceType', reactive: true })
  private correspondenceType!: CorrespondenceType[];

  @Provide({ to: 'correspondenceDescriptions', reactive: true })
  private correspondenceDescriptions!: CorrespondenceDescription[];

  @Provide({ to: 'solelyJointlyType', reactive: true })
  private solelyJointlyType!: SolelyJointly[];


  private showRHSHeader = true;
  private showAddEditInvestigationModal = false;
  private showAddEditEventModal = false;
  private showAddEditMemberModal = false;
  private showInvestigationDetailsModal = false;

  private idleSessionMgr: IDLESessionManager = new IDLESessionManager();

  private selectedInvestigation: InvestigationView = {};
  private selectedTrustTeamMember: TrustTeamMemberView = {};
  private selectedEventFormData: EventForm = null as any;

  private navItems: NavItem[] = [];

  private loadingData = false;
  private errorLoadingData = false;

  private isFromRoutine = false;
  private routineId: any = null;

  @Watch('$route.name')
  public onRouteChanged(): void {
    this.populateNavItems();
    this.updateNavItems();
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  beforeRouteEnter(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
    const c1: boolean = to.matched.some((record) => record.meta.requiresAuth);
    const c2: boolean = (store.getters.getUserAccount as AuthorizedUser)
      .authenticationStatus === AuthenticationStatusType.AppAccessPermitted;
    c1 && !c2 ? next({ name: RouteN.TA.LoginPage.n, query: { redirect: to.fullPath } }) : next();
  }

  created(): void {
    this.populateNavItems();
    this.updateNavItems();
    this.loadDataType();
    this.idleSessionMgr.run(this.idleSessionTimeoutCallback);
  }

  mounted(): void {
    window.scrollTo(0, 0);
    this.eventCtrl.on('showAddEditEventModal', this.openAddEditEventModalBox);
    this.eventCtrl.on('showAddEditInvestigationModal', this.openAddEditInvestigationModal);
    this.eventCtrl.on('showAddEditMemberModal', this.openAddEditMemberModal);
    this.eventCtrl.on('showInvestigationDetailsModal', this.openInvestigationDetailsModal);
    this.getSystemDate();
    if (this.env.length > 0) {
      setInterval(() => {
        this.getSystemDate();
      }, 10000);
    }
  }

  beforeUnmount(): void {
    this.eventCtrl.removeListener('showAddEditInvestigationModal', this.openAddEditInvestigationModal);
    this.eventCtrl.removeListener('showAddEditEventModal', this.openAddEditEventModalBox);
    this.eventCtrl.removeListener('showAddEditMemberModal', this.openAddEditMemberModal);
    this.eventCtrl.removeListener('showInvestigationDetailsModal', this.openInvestigationDetailsModal);

    this.idleSessionMgr.stop();
  }

  private openInvestigationDetailsModal(i: InvestigationView) {
    this.selectedInvestigation = i;
    this.showInvestigationDetailsModal = true;
  }

  private closeInvestigationDetailsModal() {
    this.showInvestigationDetailsModal = false;
  }

  private openAddEditEventModalBox(event: EventForm = { eventTypeId: 1 }): void {
    this.selectedEventFormData = event;
    // console.log(this.selectedEventFormData);
    this.showAddEditEventModal = true;
  }

  private closeAddEditEventModalBox(): void {
    this.selectedEventFormData = null as any;
    this.showAddEditEventModal = false;
  }

  private eventsUpdated() {
    this.eventCtrl.emit('reload-events-data');
  }

  private openAddEditInvestigationModal(investigation: InvestigationView = null as any, isFromRoutine: boolean, routineId?: number): void {
    const secondLevelRouteName = this.$route.matched[1]?.name ?? null;
    this.routineId = routineId ?? null;
    this.isFromRoutine = isFromRoutine;
    if (!investigation && secondLevelRouteName == RouteN.TA.Practice.n) {
      this.selectedInvestigation = {
        id: 0,
        latestPracticeLogData: this.selectedPractice
      }
      this.selectedInvestigation.latestPracticeLogData.practiceId = this.selectedPractice.id;
    } else if (investigation) {
      this.selectedInvestigation = investigation;
    }
    this.showAddEditInvestigationModal = !this.showAddEditInvestigationModal;
  }

  private closeAddEditInvestigationModal(): void {
    this.selectedInvestigation = {};
    this.showAddEditInvestigationModal = !this.showAddEditInvestigationModal;
  }

  private openAddEditMemberModal(member: TrustTeamMemberView = null as any): void {
    const secondLevelRouteName = this.$route.matched[1]?.name ?? null;
    if (!member && secondLevelRouteName == RouteN.TA.Investigator.n) {
      this.selectedTrustTeamMember = {
        id: 0
      }
    } else if (member) {
      this.selectedTrustTeamMember = member;
    }
    this.showAddEditMemberModal = !this.showAddEditMemberModal;
  }

  private closeAddEditMemberModal(): void {
    this.selectedTrustTeamMember = {};
    this.showAddEditMemberModal = !this.showAddEditMemberModal;
  }

  private updateNavItems(): void {
    this.navItems.forEach((navItem) => {
      navItem.status = NavItemStatusID.NotCurrent;
      if (navItem.routeSecName === this.$route.name || this.$route.matched[1].name == navItem.routeSecName) {
        navItem.status = NavItemStatusID.Current;
      }
    });
  }

  private idleSessionTimeoutCallback(): void {
    this.$router.push({ name: RouteN.TA.LogoutPage.n });
  }

  private async loadDataType(): Promise<void> {
    try {
      this.loadingData = true;
      this.errorLoadingData = false;
      const resp: any[] = await Promise.all([
        this.apiService.CodeApi?.apiV2CodeGetStatusGet(),
        this.apiService.CodeApi?.apiV2CodeGetLeaveTypesGet(),
        this.apiService.CodeApi?.apiV2CodeGetInvestigationCategoryGet(),
        this.apiService.CodeApi?.apiV2CodeGetTimeEntryTypesGet(),
        this.apiService.CodeApi?.apiV2CodeGetUserGroupsGet(),
        this.apiService.CodeApi?.apiV2CodeGetTimeEntryActivitiesGet(),
        this.apiService.CodeApi?.apiV2CodeGetPrioritiesGet(),
        this.apiService.CodeApi?.apiV2CodeGetTrustAccountStatusesGet(),
        this.apiService.CodeApi?.apiV2CodeGetNoteTypesGet(),
        this.apiService.CodeApi?.apiV2CodeGetPracticeRisksGet(),
        this.apiService.CodeApi?.apiV2CodeGetPracticeRiskIndicatorsGet(),
        this.apiService.CodeApi?.apiV2CodeGetCorrespondenceTypesGet(),
        this.apiService.CodeApi?.apiV2CodeGetSolelyJointliesGet(),
        this.apiService.CodeApi?.apiV2CodeGetAccountTypesGet(),
        this.apiService.CodeApi?.apiV2CodeGetCorrespondenceDescriptionsGet()
      ]);

      this.statusType = resp[0].data.data as Status[];
      this.leaveType = resp[1].data.data as LeaveType[];
      this.investigationCategory = resp[2].data.data as InvestigationCategory[];
      this.timeEntryType = resp[3].data.data as TimeEntryType[];
      this.userGroups = resp[4].data.data as UserGroup[];
      this.timeEntryActivity = resp[5].data.data as TimeEntryActivity[];
      this.priorities = resp[6].data.data as Priority[];
      this.trustAccountStatus = resp[7].data.data as TrustAccountStatus[];
      this.noteType = resp[8].data.data as NotesType[];
      this.practiceRisks = resp[9].data.data as PracticeRisk[];
      this.practiceRiskIndicators = resp[10].data.data as PracticeRiskIndicator[];
      this.correspondenceType = resp[11].data.data as CorrespondenceType[];
      this.solelyJointlyType = resp[12].data.data as SolelyJointly[];
      const correspondenceDescriptions = resp[14].data.data as CorrespondenceDescription[];
      this.correspondenceDescriptions = correspondenceDescriptions.sort((a, b) => (a.description && b.description) ? a.description.localeCompare(b.description) : 0);
    } catch (err) {
      this.errorLoadingData = true;
      console.log(err);
    } finally {
      this.loadingData = false;
    }
  }

  get isFixHeader(): boolean {
    // switch (this.$route.name) {
    //   case RouteN.TA.Home.n:
    //     return true;
    //   default:
    //     return true;
    // }
    return true;
  }

  get usrAcct(): AuthorizedUser {
    return store.getters.getUserAccount;
  }

  get selectedPractice(): PracticeView {
    return store.getters.getSelectedPractice;
  }

  private populateNavItems(): void {

    const pagesWithMainNav: string[] = [
      RouteN.TA.Home.n,
      RouteN.TA.Investigations.n,
      RouteN.TA.Routines.n,
      RouteN.TA.FollowUp.n,
      RouteN.TA.TimesheetApproval.n,
      RouteN.TA.TrustData.n,
      RouteN.TA.TrustDataPractices.n,
      RouteN.TA.TrustDataTrustTeam.n,
      RouteN.TA.TrustDataInvestigationType.n,
      RouteN.TA.TrustDataBanks.n,
      RouteN.TA.TrustDataAccountingSoftware.n,
      RouteN.TA.TrustDataExternalExaminer.n,
      RouteN.TA.TrustDataExternalExaminerApproval.n,
      RouteN.TA.TrustDataExternalExaminerSignUpApproval.n,
      RouteN.TA.TrustDataPageSettings.n,
    ];

    const pagesWithInvestigatorNav: string[] = [
      RouteN.TA.Investigator.n,
      RouteN.TA.InvestigatorDashboard.n,
      RouteN.TA.InvestigatorInvestigations.n,
      RouteN.TA.InvestigatorCalendar.n,
      RouteN.TA.InvestigatorTimesheets.n
    ];

    const pagesWithPracticeNav: string[] = [
      RouteN.TA.Practice.n,
      RouteN.TA.PracticeDashboard.n,
      RouteN.TA.PracticeInvestigationDetails.n,
      RouteN.TA.PracticeBank.n,
      RouteN.TA.PracticeAccountingDetails.n,
      RouteN.TA.PracticeNotes.n,
      RouteN.TA.PracticePeople.n,
      RouteN.TA.PracticeCorrespondence.n,
      RouteN.TA.PracticeLinkedPractice.n,
      RouteN.TA.PracticeTrustCompliance.n,
    ];

    const pagesWithExternalExaminerNav: string[] = [
      RouteN.TA.ExternalExaminer.n,
      RouteN.TA.ExternalExaminerDashboard.n,
    ];

    const v1 = pagesWithMainNav.filter(x => x == this.$route.name).length > 0;
    const v2 = pagesWithInvestigatorNav.filter(x => x == this.$route.name).length > 0;
    const v3 = pagesWithPracticeNav.filter(x => x == this.$route.name).length > 0;
    const v4 = pagesWithExternalExaminerNav.filter(x => x == this.$route.name).length > 0;
    // console.log(v1, v2, v3, v4);
    if (v1) {
      this.navItems = this.mainNavigationBarItems;
    } else if (v2) {
      this.navItems = this.investigatorNavigationBarItems;
    } else if (v3) {
      this.navItems = this.practiceNavigationBarItems;
    } else if (v4) {
      this.navItems = this.externalExaminerNavigationBarItems;
    } else {
      this.navItems = [];
    }

  }

  get mainNavigationBarItems(): NavItem[] {
    return [
      new NavItem('Home', RouteN.TA.Home.n, undefined, true, NavItemStatusID.Current),
      new NavItem(
        'Investigations',
        RouteN.TA.Investigations.n,
        undefined,
        this.$accessPermitted(this.usrAcct.user.roles, RouteN.TA.Investigations.r),
        NavItemStatusID.NotCurrent
      ),
      new NavItem(
        'Routines',
        RouteN.TA.Routines.n,
        undefined,
        this.$accessPermitted(this.usrAcct.user.roles, RouteN.TA.Routines.r),
        NavItemStatusID.NotCurrent
      ),
      new NavItem(
        'Follow Up',
        RouteN.TA.FollowUp.n,
        undefined,
        this.$accessPermitted(this.usrAcct.user.roles, RouteN.TA.FollowUp.r),
        NavItemStatusID.NotCurrent
      ),
      new NavItem(
        'Timesheet',
        RouteN.TA.TimesheetApproval.n,
        undefined,
        this.$accessPermitted(this.usrAcct.user.roles, RouteN.TA.TimesheetApproval.r),
        NavItemStatusID.NotCurrent
      ),
      new NavItem(
        'Maintain Trust Data',
        RouteN.TA.TrustData.n,
        undefined,
        this.$accessPermitted(this.usrAcct.user.roles, RouteN.TA.TrustData.r),
        NavItemStatusID.NotCurrent
      ),
      new NavItem(
        'Complaints',
        '',
        this.$route.query,
        true,
        NavItemStatusID.NotCurrent,
        NavItemTypeID.ExternalLink,
        Url.PowerBIComplaints
      ),
      new NavItem(
        'Historical Investigation',
        '',
        this.$route.query,
        true,
        NavItemStatusID.NotCurrent,
        NavItemTypeID.ExternalLink,
        Url.PowerBIHestoricalInvestigation
      ),
    ];
  }

  get investigatorNavigationBarItems(): NavItem[] {
    return [
      new NavItem(
        'Home',
        RouteN.TA.InvestigatorDashboard.n,
        this.$route.query,
        this.$accessPermitted(this.usrAcct.user.roles, RouteN.TA.InvestigatorDashboard.r),
        NavItemStatusID.NotCurrent
      ),
      new NavItem(
        'Investigations',
        RouteN.TA.InvestigatorInvestigations.n,
        this.$route.query,
        this.$accessPermitted(this.usrAcct.user.roles, RouteN.TA.InvestigatorInvestigations.r),
        NavItemStatusID.NotCurrent
      ),
      new NavItem(
        'Calendar',
        RouteN.TA.InvestigatorCalendar.n,
        this.$route.query,
        this.$accessPermitted(this.usrAcct.user.roles, RouteN.TA.InvestigatorCalendar.r),
        NavItemStatusID.NotCurrent
      ),
      new NavItem(
        'Timesheets',
        RouteN.TA.InvestigatorTimesheets.n,
        this.$route.query,
        this.$accessPermitted(this.usrAcct.user.roles, RouteN.TA.InvestigatorTimesheets.r),
        NavItemStatusID.NotCurrent
      ),
    ];
  }

  get practiceNavigationBarItems(): NavItem[] {
    return [
      new NavItem(
        'Home',
        RouteN.TA.PracticeDashboard.n,
        this.$route.query,
        this.$accessPermitted(this.usrAcct.user.roles, RouteN.TA.PracticeDashboard.r),
        NavItemStatusID.NotCurrent
      ),
      new NavItem(
        'Investigations',
        RouteN.TA.PracticeInvestigationDetails.n,
        this.$route.query,
        this.$accessPermitted(this.usrAcct.user.roles, RouteN.TA.PracticeInvestigationDetails.r),
        NavItemStatusID.NotCurrent
      ),
      new NavItem(
        'Bank',
        RouteN.TA.PracticeBank.n,
        this.$route.query,
        this.$accessPermitted(this.usrAcct.user.roles, RouteN.TA.PracticeBank.r),
        NavItemStatusID.NotCurrent
      ),
      new NavItem(
        'Accounting',
        RouteN.TA.PracticeAccountingDetails.n,
        this.$route.query,
        this.$accessPermitted(this.usrAcct.user.roles, RouteN.TA.PracticeAccountingDetails.r),
        NavItemStatusID.NotCurrent
      ),
      new NavItem(
        'Notes',
        RouteN.TA.PracticeNotes.n,
        this.$route.query,
        this.$accessPermitted(this.usrAcct.user.roles, RouteN.TA.PracticeNotes.r),
        NavItemStatusID.NotCurrent
      ),
      new NavItem(
        'People',
        RouteN.TA.PracticePeople.n,
        this.$route.query,
        this.$accessPermitted(this.usrAcct.user.roles, RouteN.TA.PracticePeople.r),
        NavItemStatusID.NotCurrent
      ),
      new NavItem(
        'Correspondence',
        RouteN.TA.PracticeCorrespondence.n,
        this.$route.query,
        this.$accessPermitted(this.usrAcct.user.roles, RouteN.TA.PracticeCorrespondence.r),
        NavItemStatusID.NotCurrent
      ),
      new NavItem(
        'Linked practices',
        RouteN.TA.PracticeLinkedPractice.n,
        this.$route.query,
        this.$accessPermitted(this.usrAcct.user.roles, RouteN.TA.PracticeLinkedPractice.r),
        NavItemStatusID.NotCurrent
      ),
      new NavItem(
        'Trust Compliance',
        RouteN.TA.PracticeTrustCompliance.n,
        this.$route.query,
        this.$accessPermitted(this.usrAcct.user.roles, RouteN.TA.PracticeTrustCompliance.r),
        NavItemStatusID.NotCurrent
      )
    ];
  }

  get externalExaminerNavigationBarItems(): NavItem[] {
    return [
      new NavItem(
        'Home',
        RouteN.TA.ExternalExaminerDashboard.n,
        this.$route.query,
        this.$accessPermitted(this.usrAcct.user.roles, RouteN.TA.PracticeDashboard.r),
        NavItemStatusID.NotCurrent
      )
    ];
  }

  private displayDate = new Date();
  private isToday = false;
  private showDateTip = true;

  get env(): string {
    const local = window.location.href.indexOf('localhost') > 0 ? 'DEV' : '';
    const dev = window.location.href.indexOf('-dev') > 0 ? 'DEV' : '';
    const sit = window.location.href.indexOf('-sit') > 0 ? 'SIT' : '';
    return local + dev + sit;
  }

  private isDateToday(dateString: string) {
    // Parse the date string into a Date object
    const date = new Date(dateString);

    // Get today's date
    const today = new Date();

    // Compare years, months, and days
    return (
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate()
    );
  }

  private getSystemDate(): void {
    if (this.showDateTip) {
      this.apiService?.DateApi.apiV2DateGetBaseDateGet()
        .then((res: any) => {
          this.displayDate = new Date(res.data);
          this.isToday = this.isDateToday((this.displayDate.toISOString()));
        })
        .catch((err: any) => {
          console.log('get date failed: ', err);
        })
    }
  }

}


